module.exports = __webpack_public_path__ + "static/media/sple.2a3de4b6.png";